import connectionProxy from '../connectionProxy'

export const getResponsibleInfos = (document, building) => {
  return connectionProxy.get(`responsibles/${document}?building=${building}`)
}

export const sendExitRequest = ({ id, responsibleId, studentsIds }) => {
  return connectionProxy.post('exit_requests', {
    'administrator_id': id,
    'responsible_id': responsibleId,
    'student_ids': studentsIds
  })
}
